import { useState, useRef, useEffect } from 'react';
import { AgGridReact } from 'ag-grid-react';
import AttachmentPopup from './attachmentPopup';
import { DetailDateTimeFormatter, NameFormatter } from '../../../shared/controls/formatters';
import apiServices from '../../../services/service';
import PreviewFile from '../previewfile';
import { useDispatch } from 'react-redux';
import { fetchAttachmentsAndAppendToModule } from '../../../redux/actions';
import { toast } from 'react-toastify';
import { Button, Modal } from 'react-bootstrap';
import { SizeConverter } from '../../../shared/controls/formatters/SizeConverter';

const Attachments = ({ localData, module }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [showAttachementPopup, setShowAttachementPopup] = useState(false);
  const [filesAttached, setFilesAttached] = useState([]);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [deleteAttachmentData, setDeleteAttachmentData] = useState([]);

  const handleOpenDeletePopup = (data) => {
    setShowDeletePopup(true);
    setDeleteAttachmentData(data);
  };

  const handleCloseDeletePopup = () => {
    setShowDeletePopup(false);
  };

  const handleFileChange = (event) => {
    const uploadedFiles = Array.from(event.target.files);
    setFilesAttached((prevFiles) => [...prevFiles, ...uploadedFiles]);
    event.target.value = ''; // Clear the input so the same file can be uploaded again
  };

  const handleDelete = (index) => {
    setFilesAttached((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  const handleView = (file) => {
    alert(`Viewing file: ${file.name}`);
    // Add custom view logic (e.g., preview the file)
  };
  // Function to open the first popup
  const openPopup1 = () => {
    setFilesAttached([]);
    setShowAttachementPopup(true);
  };
  const handleDownload = (fileName, displayName) => {
    apiServices.downloadFileCRM(fileName, 'Attachments', displayName);
  };
  const handlePreview = async (fileName) => {
    let blob = await apiServices.previewFileCRM(fileName, 'Attachments');
    return <PreviewFile blob={blob} fileName={fileName} />;
  };
  const handleClickDeleteAttachment = (paramsValue) => {
    setLoading(true);
    // Creating the desired JSON object
    const data = {
      id: paramsValue.id,
      module: module,
      moduleId: localData?.id,
    };
    console.log('Data==>>', data);
    apiServices
      .deleteAttachment(data)
      .then((response) => {
        if (response.status === 200) {
          handleCloseDeletePopup();
          dispatch(
            fetchAttachmentsAndAppendToModule({
              moduleName: module,
              id: localData?.id,
            })
          );
          setLoading(false);
          toast.success('Attachment Deleted Successfully!', {
            position: 'top-right',
          });
        }
      })
      .catch((error) => {
        console.error('Error while deleting attachment:', error);
        setLoading(false);
      });
  };
  // Function to close the first popup
  const closeAttachementPopup = () => {
    setFilesAttached([]);
    setShowAttachementPopup(false);
  };
  const handleSaveAttachement = async () => {
    setLoading(true);
    const timestamp = new Date().toISOString().replace(/[:.]/g, '-');
    // Preprocess files to create renamed files and metadata array
    const { processedFiles, dataArray } = Array.from(filesAttached).reduce(
      (acc, file) => {
        const newFileName = `${localData?.id}_${timestamp}_${file.name}`;
        const renamedFile = new File([file], newFileName, { type: file.type });
        acc.processedFiles.push(renamedFile);
        acc.dataArray.push({
          fileName: `${file.name}`,
          cloudStorageURL: newFileName,
          size: `${file.size}`,
          module: module,
          moduleId: localData?.id,
        });
        apiServices
          .createAttachment({
            fileName: `${file.name}`,
            cloudStorageURL: newFileName,
            size: `${file.size}`,
            module: module,
            moduleId: localData?.id,
          })
          .then((response) => {
            if (response.status === 200) {
              dispatch(
                fetchAttachmentsAndAppendToModule({
                  moduleName: module,
                  id: localData?.id,
                })
              );
              setLoading(false);
              toast.success('Attachment Created Successfully!', {
                position: 'top-right',
              });
            }
          })
          .catch((error) => {
            console.error('Error while creating attachment:', error);
            setLoading(false);
          });
        return acc;
      },
      { processedFiles: [], dataArray: [] }
    );
    console.log('dataArray==>>', dataArray);
    setFilesAttached([]);
    try {
      const uploadSuccess = await apiServices.uploadFilesCRM(processedFiles, 'Attachments');
      if (uploadSuccess) {
      } else {
        console.error('File upload failed.');
      }
    } catch (error) {
      console.error('Error during file upload:', error);
    }
    setShowAttachementPopup(false);
  };

  const localGridRef = useRef();
  const attachmentColumnDefs = [
    {
      headerName: 'Actions',
      cellRenderer: (params) => {
        const paramsValue = { ...params.data };
        return (
          <div className="action-menu">
            <img
              style={{ cursor: 'pointer' }}
              src="/assets/images/downloadIcon.png"
              onClick={() => handleDownload(paramsValue.cloudStorageURL, paramsValue.fileName)}
              alt="Download"
              width="12px"
            ></img>
            <img
              src="/assets/images/trash.png"
              onClick={() => handleOpenDeletePopup(paramsValue)}
              alt="Delete Attachment"
              width="12px"
              title="Delete Attachment"
            ></img>
          </div>
        );
      },
      maxWidth: 100,
      sortable: false,
      filter: false,
      pinned: 'left',
    },
    { headerName: 'File Name', field: 'fileName', width: 150 },
    {
      headerName: 'Attached By',
      field: 'createdBy',
      width: 150,
      valueFormatter: (params) => NameFormatter(params.value),
    },
    {
      headerName: 'Date Added (UTC)',
      field: 'createdDateTime',
      width: 150,
      valueFormatter: (params) => DetailDateTimeFormatter(params.value),
    },
    {
      headerName: 'Size',
      field: 'size',
      width: 150,
      valueFormatter: (params) => SizeConverter(params.value),
    },
  ];

  const parentGridRef = useRef(null);
  useEffect(() => {
    if (parentGridRef.current) {
      const child = parentGridRef.current.firstElementChild;

      if (child) {
        child.classList.add('gridHeight');
      }
    }
  }, []);

  return (
    <div className="row" id="attachment_popup">
      <div className="col-12 col-sm-12 col-md-12">
        <div className="infoBox">
          <div className="addlead-header">
            <label htmlFor="" className="flex-div align-items-center">
              <img className="me-2" src="../assets/images/attachmentIcon.svg" alt="" />
              Attachments
            </label>
            <button type="button" className="btn btn-outline-primary attBtn" onClick={openPopup1}>
              Attach file to upload
            </button>
          </div>
          <div className="leadcontent">
            <>
              <div className="row">
                <div className="col-12 col-md-12">
                  <div className="cutome_ag_theme" id="viewPageGrid">
                    <div className="ag-theme-balham tbl_height" ref={parentGridRef}>
                      <AgGridReact
                        rowData={localData?.attachments}
                        columnDefs={attachmentColumnDefs}
                        defaultColDef={{
                          flex: 1,
                          minWidth: 100,
                          resizable: true,
                        }}
                        rowSelection="multiple"
                        alwaysShowVerticalScroll={true}
                        ref={localGridRef}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </>
          </div>

          {/* Popup Overlay */}
          {showAttachementPopup && (
            <AttachmentPopup
              handleClose={closeAttachementPopup}
              handleSave={handleSaveAttachement}
              handleFileChange={handleFileChange}
              handleDelete={handleDelete}
              handleView={handleView}
              filesAttached={filesAttached}
              loading={loading}
            />
          )}
          {showDeletePopup && (
            <Modal show={showDeletePopup} onHide={handleCloseDeletePopup} className="modal-delete">
              <div className="warning-content">
                <div className="alertImg">
                  <img src="../assets/images/delete-record.png" alt="Delete Record"></img>
                </div>
                <div className="warningText">Are you sure you want to delete this Attachment?</div>
                <div className="warningBtn">
                  <Button variant="secondary" className="btn" onClick={handleCloseDeletePopup}>
                    Cancel
                  </Button>
                  <Button
                    variant="danger"
                    className="btn"
                    onClick={() => handleClickDeleteAttachment(deleteAttachmentData)}
                  >
                    Confirm Delete
                  </Button>
                </div>
              </div>
            </Modal>
          )}
        </div>
      </div>
    </div>
  );
};
export default Attachments;
